import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import ImageGallery from "react-image-gallery";
require("./GalleryModal.css");

const PhotosModal = (props: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  function getImages() {
    return <ImageGallery lazyLoad={true} items={props.imagesList} />;
  }

  return (
    <>
      <Button
        w="100%"
        colorScheme={"blue"}
        disabled={!props.imagesList.length}
        onClick={onOpen}
      >
        Repair Photos
      </Button>

      <Modal
        isCentered
        closeOnOverlayClick={true}
        isOpen={isOpen}
        size={"6xl"}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props?.props.currProgress.label} Photos</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>{getImages()}</ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PhotosModal;
